import React, { ChangeEvent, Fragment } from 'react';
import { connect } from 'react-redux';

import { withStyles, MuiThemeProvider, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";

import { Typography, Grid, List, ListItem, ListItemText, Select, MenuItem, Backdrop, Menu } from '@material-ui/core';

import { AppState, Actions, store, IPageState } from '../../appredux'
import CONFIG from '../../cfg/config';
import { MenuService, AsortMenuWiersz, AsortGrupyWiersz, Font, AsortWWWMenuNagl } from '../../api';

import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import { TableRow } from '@material-ui/core';
import Button from '@material-ui/core/Button';

import SearchIcon from '@mui/icons-material/Search';

import CircularProgress from '@material-ui/core/CircularProgress';
import { IconButton } from '@material-ui/core';
import AppsIcon from '@mui/icons-material/Apps';
import MenuIcon from '@mui/icons-material/Menu';

import { AddItem } from '../PanelRightBasket';
import DialogChangeItem from '../dialog/ChangeItem';
import themeDialog from '../../themes-dialog';
import { fontSelect } from '../../fonts';
import { hexToRgb, sendErrorLog } from '../common/helpers';
import KartaDanie from './KartaDanie';
import { SelectChangeEvent } from '@mui/material/Select';

export const tabStyle = {
  colorBackground: 'white',
  colorMain: "lightseagreen", //#ffa500
  colorText: 'white',
  colorTextAlt: "lightseagreen", //#ffa500
  colorHover: "#2c9993", //#e69d17
};

//PM 2021-03-11
//wstrzykniecie tylko uzywanych pol z magazynu danych
type ZamowienieProps = {
  page: IPageState,
  windowWidth: number,
}

type ZamowienieState = {
  headerIds: number[],
  headers: (AsortMenuWiersz & { kolor?: boolean })[],
  item: AsortGrupyWiersz,

  selectedMenu: number,
  anchorEl: any,

  asort: AsortGrupyWiersz[],
  view: number,
}

class Zamowienie extends React.Component<ZamowienieProps & WithStyles<typeof styles>, ZamowienieState> {
  textTheme = fontSelect(this.props.page.fonts, 7, 1) as React.CSSProperties;
  selectedTheme = fontSelect(this.props.page.fonts, 13, 1) as React.CSSProperties;
  contentTheme = fontSelect(this.props.page.fonts, 8, 2) as React.CSSProperties;

  constructor(props: ZamowienieProps & WithStyles<typeof styles>) {
    super(props, {});
    //this.getData();

    let id = this.props.page.selectedMenuItem;
    let data = this.props.page.asortHeaders.filter((e) => e.menu_id === id)
    let ids: number[] = [];
    data.forEach((e) => { ids.push(e.grupa_id) });
  
    this.state = {
      headerIds: ids,
      headers: data,
      item: new AsortGrupyWiersz(),

      selectedMenu: ids[0],
      anchorEl: null,

      asort: [],
      view: 3,
    };
  }

  componentDidMount() {
    //this.getData();
    this.addItemFunc(this.state.headerIds[0])
  }

  //PM 2021-03-11
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  componentDidUpdate(prevProps: ZamowienieProps, prevState: ZamowienieState) {
    if (prevProps.page.menuItems !== this.props.page.menuItems || prevProps.page.selectedMenuItem !== this.props.page.selectedMenuItem) {
      let id = this.props.page.selectedMenuItem;
      let data = this.props.page.asortHeaders.filter((e) => e.menu_id === id)
      let ids: number[] = [];
      data.forEach((e) => { ids.push(e.grupa_id) });
      this.setState({ headerIds: ids, headers: data, selectedMenu: ids[0] });

      this.addItemFunc(ids[0]);
    }
    //if (prevProps.page.selectedMenuItem !== this.props.page.selectedMenuItem) {
    if (prevProps.page.refresh !== this.props.page.refresh) {
      //this.getData();
    }

  }

  setView = (view: number) => {
    if(this.state.view !== view) this.setState({view: view})
  }

  // handleChangeView = (event: ChangeEvent<{ name?: string | undefined; value: unknown; }>) => {
  //   if(this.state.view !== Number(event.target.value)) this.setState({view: Number(event.target.value)})
  // };

  setScroll = () => {
    //this.setState({scroll: false})
  }

  setItem = (item: AsortGrupyWiersz) => {
    if(this.state.item.asort_id !== item.asort_id) this.setState({item: item})
  }

  addItemFunc = async (id: number) => {
    
    this.setState({  selectedMenu: id }) //scroll: true,
    this.getDataAsort(id)
   
  }

  getDataAsort = (id: number) => {
    //let id = this.props.page.selectedMenuItem;
    this.setState({asort: []})
   
    MenuService.getAsortFoto({ hotelId: CONFIG.hotelID, aOperatorId: Number(sessionStorage.getItem("operator_id")), aGrupaId: id }, {})
    .then(
      (res : any) => {
        //console.log(res.result)
        //store.dispatch(Actions.pageState.getAsort(res.result));
        this.setState({asort: res.result})
        }
      )        
    .catch( (err : any) => {
      console.error
      } 
    );

  };


  


  //PM 2021-03-17
  checkUndefined = (asort: AsortGrupyWiersz[][]) => {
    if (asort.length <= 0) return false;

    let value = true;

    asort.forEach(x => {
      if (x == undefined) {
        value = false;
      }
    });

    return value;
  }

  openMenu = (event: any) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  closeMenu = () => {
    this.setState({ anchorEl: null });
  };


  //PM 2021-03-11
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  render() {
    const classes = this.props.classes;

    const openMenu = Boolean(this.state.anchorEl);

    const header = this.state.headers;
    let data: AsortGrupyWiersz[][] = [];
    let asort: AsortGrupyWiersz[][] = [];

    let length = 0
  
    header.forEach(e => {
      data = this.props.page.asort.filter(el => el[0] && el[0].grupa_id === e.grupa_id);   
      asort.push(data[0]);
      length += e.grupa_opis.length
    })

    



    let asortAsort = this.state.asort

    //width: `calc((100% )/${header.length})`

    return (
      <>

        <List style={{ width: "100%", display: "inline-table", paddingTop: "0", marginTop: "-20px", paddingBottom: "12px" }}>
          
            {header.map((item: AsortMenuWiersz, index: any) => (
              <ListItem className={classes.list}
                key={index}
                button
                onClick={() => this.addItemFunc(item.grupa_id)}
                style={{width: `calc((100% )*${item.grupa_opis.length / length})`, minWidth: `calc(${item.grupa_opis.length * 10.1}px)`, display: "inline-table"}}
              >
                <ListItemText primary={<Typography color="primary" component="h6" style={{ ...this.textTheme, color: this.state.selectedMenu == item.grupa_id ? this.selectedTheme.color : this.textTheme.color }} >{item.grupa_opis}</Typography>} />
              </ListItem>
            ))}

          </List>

          <Button className={`${classes.deleteAll}`} style={{position: "absolute", top: "10px", right: "-2px", ... this.textTheme}}
            onClick={this.openMenu}
            >  
              {this.state.view}
              </Button>

        {/* <Select
          labelId="select-small-label"
          id="select-small"
          value={this.state.view}
          label="Age"
          onChange={this.handleChangeView}
        >
          <MenuItem value={1}>1</MenuItem>
          <MenuItem value={2}>2</MenuItem>
          <MenuItem value={3}>3</MenuItem>
        </Select> */}

        {/* <div style={{ width: "100%", textAlign: "end", margin: "0px 0px 10px 0px", paddingBottom: this.state.view === 2 ? "16px" : "0px" }}>
                <IconButton
                  className={classes.textButton}
                  onClick={() => this.setView(1)}
                  style={this.state.view === 1 ? selectedStyle : notSelectedStyle}
                >
                  1
                </IconButton>
                <IconButton
                  className={classes.textButton}
                  onClick={() => this.setView(2)}
                  style={this.state.view === 2 ? selectedStyle : notSelectedStyle}
                >
                  2
                </IconButton>
                <IconButton
                  className={classes.textButton}
                  onClick={() => this.setView(3)}
                  style={this.state.view === 3 ? selectedStyle : notSelectedStyle}
                >
                  3
                </IconButton>
          </div> */}

      
       <Fragment>
          

          {this.state.view === 1 && asortAsort? asortAsort.map((danie1: AsortGrupyWiersz, index: number) => (
            <KartaDanie 
              danie = { danie1 }
              key={ danie1.asort_id }
              view={this.state.view}
              //lang={this.props.page.lang}
              ostatni={asortAsort && asortAsort.length === index +1}
              selected={this.state.item.asort_id === danie1.asort_id}
              setItem={this.setItem}
              scroll={false}
              setScroll={this.setScroll}
            />
          )) : (this.state.view === 2 || this.state.view === 3) && asortAsort[0]?
           <Grid container spacing={4}>
            {asortAsort.map((danie1: AsortGrupyWiersz, index: number) => (
            <KartaDanie 
              danie = { danie1 }
              key={ danie1.asort_id }
              view={this.state.view}
              //lang={this.props.page.lang}
              ostatni={asortAsort && asortAsort.length === index +1} 
              selected={this.state.item.asort_id === danie1.asort_id}
              setItem={this.setItem}
              scroll={false}
              setScroll={this.setScroll}
            />
            )) }
         </Grid> : <div style={{width: "100%", textAlign: "center"}}><CircularProgress className={classes.progress}/></div> }
          
         

        </Fragment>


        <Backdrop className={classes.backdrop} open={openMenu}>
          <Menu
            id="long-menu"
            anchorEl={this.state.anchorEl}
            keepMounted
            elevation={15}
            open={openMenu}
            onClose={this.closeMenu}
            PaperProps={{
              style: {
                //maxHeight: 10 * 4.5,
                width: '7ch',
                left: "200px",
                top: "200px"
                //paddingTop: "0"
              },
            }}

            MenuListProps={{
              style: {
                //maxHeight: 10 * 4.5,
                //width: '30ch',
                color: "#555",
                width: "100%",
                paddingRight: "0"
                //paddingTop: "0",
                //paddingBottom: "0"
              },
            }}
          >

            {/*<hr/>*/}
            {/* <Typography 
                                gutterBottom component="h6" style={{padding: "8px 16px"}}
                                color='textSecondary'
                              >
                                <b>{"Dane"}</b>
                              </Typography> */}

            {[1,2,3].map(menuItem => (
              <MenuItem key={menuItem}  onClick={() => {this.setView(menuItem); this.closeMenu()}} className={classes.menuItem}>
                <Typography className={classes.menuText}
                  color='textSecondary'
                  variant='caption'
                  //style={{... selectedStyle}}
                  style={{...this.textTheme, color: this.state.view === menuItem ? this.selectedTheme.color : this.textTheme.color}}
                  
                >
                  {menuItem}
                </Typography>
              </MenuItem>
            ))}



          </Menu>
        </Backdrop>

       
      </>
    )
  }
}

const styles = (theme: Theme) => ({
  cell: {
    padding: "2px 10px 3px 2px",
  },
  add: {
    padding: "0",
    minWidth: "25px",
    width: "25px",
    height: "25.6px",
    //border: "1px solid #aaa",
    //borderRadius: "0"
    "&:hover": {
      background: "transparent"
    }
  },
  hr: {
    border: "0",
    borderBottom: "1px solid #ddd",
  },
  table: {
    marginTop: "1.2em",
    marginBottom: "1.2em"
  },
  label: {
    marginTop: "-4px"
  },
  labelPhone: {
    marginTop: "0px"
  },
  head: {
    paddingBottom: "5px"
  },
  progress: { 
    margin: theme.spacing(2) 
  },
  iconButton: {
    padding: "4px"
  },
  icon: {
    width: "0.6em !important",
    height: "0.6em !important",
  },
  textButton: {
    fontSize: "11px",
    width: "0.4em !important",
    height: "0.6em !important",
  },


  input: {
    fontSize: "14px",
    //fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
    lineHeight: "14px",
    fontWeight: "bold" as "bold",
    textTransform: "lowercase" as "lowercase",
    padding: "14px",
    backgroundColor: tabStyle.colorBackground,
    "&:hover": {
      background: tabStyle.colorHover, //"#007000",
      color: tabStyle.colorBackground,
    }
  },
  inputChosen: {
    fontSize: "14px",
    //fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
    lineHeight: "14px",
    fontWeight: "bold" as "bold",
    textTransform: "lowercase" as "lowercase",
    padding: "14px",
    backgroundColor: tabStyle.colorMain, //"#56d242",
    "&:hover": {
      background: tabStyle.colorHover, //"#007000",
      color: tabStyle.colorBackground,
    }
  },
  border: {
    borderStyle: "solid",
    borderWidth: "2px",
    //borderColor: theme.palette.primary.main,
    ///borderColor: "lightgrey",
    borderColor: "lavender",
    borderRadius: "0px",
    //borderRadius: "4px",
    "&:hover": {
      //borderRadius: "4px",
      borderStyle: "solid",
      borderWidth: "2px",
      borderRadius: "0px",
      borderColor: "lavender",
    },
  },
  inputAlt: {
    color: tabStyle.colorTextAlt
  },
  inputText: {
    color: tabStyle.colorText
  },
  list: {
    //borderTop: "1px solid rgba(224, 224, 224, 1)",
    borderBottom: "1px solid rgba(224, 224, 224, 1)",
    paddingLeft: "0px",
    paddingRight: "0px",
    textAlign: "center" as "center",
    // "&:first-child": {
    //   borderTopRightRadius: "4px",
    //   borderTopLeftRadius: "4px"
    // }
    //"&:last-child": {
    //  borderBottom: "1px solid rgba(224, 224, 224, 1)"
    //}
  },
  menuItem: {
    borderBottom: "1px solid rgba(224, 224, 224, 1)",
    "&:last-child": {
      borderBottom: "0"
    }
  },
  deleteAll: {
    padding: "0",
    minWidth: "25px",
    width: "25px",
    height: "25px",
    border: "1px solid #aaa",
    //borderRadius: "0",
    float: "right" as "right"
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  menuText: {
    fontSize: "0.85rem"
  },
});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState,
});

export default connect(mapStateToProps)(withStyles(styles)(Zamowienie));